<script>
    import PageHeadingSection from "../ui/PageHeadingSection.svelte";

</script>
<svelte:head>
	<title>Polityka prywatności - WW Notariusz</title>
	<meta name="description" content="Informacje o polityce prywatności kancelarii" />
</svelte:head>

<PageHeadingSection 
	title="Polityka prywatności - WW Notariusz"
	imageUrl="/rodo.jpg"
/>

<section class="section">
	<div class="container privacy-main">
		<h2>Informacje ogólne</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				Operatorem serwisu ww-notariusz.pl jest Agnieszka Wencel i Iwona Wrześniak, prowadzący działalność pod nazwą KANCELARIA NOTARIALNA AGNIESZKA WENCEL IWONA WRZEŚNIAK, z adresem ul. Krakowska nr 180 lok. A3, 52-015 Wrocław, posiadający REGON: 525621158 oraz NIP: 8992963822.
			</p>
			<p class="paragraph">
				Serwis ww-notariusz.pl zbiera informacje o użytkownikach oraz ich zachowaniach poprzez dobrowolnie wprowadzone informacje w formularzach.
			</p>
		</div>
		

		<h2>Informacje w formularzach</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				Serwis zbiera informacje podane dobrowolnie przez użytkowników poprzez formularze dostępne na stronie.
			</p>
			<p class="paragraph">
				Dane podane w formularzu nie są udostępniane podmiotom trzecim inaczej, niż za wyraźną zgodą użytkownika.
			</p>
			<p class="paragraph">
				Dane podane w formularzu mogą być przetwarzane w celu:
			</p>
			<ul>
				<li>Dokonania procesu obsługi zgłoszenia serwisowego,</li>
				<li>Nawiązania kontaktu handlowego,</li>
				<li>Innych celów wynikających z funkcji konkretnego formularza.</li>
			</ul>
		</div>

		<h2>Udostępnienie danych</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				Dane zbierane w serwisie mogą być udostępniane podmiotom zewnętrznym wyłącznie w granicach prawnie dozwolonych.
			</p>
			<p class="paragraph">
				Dane umożliwiające identyfikację osoby fizycznej będą udostępniane wyłącznie za wyraźną zgodą tej osoby.
			</p>
			<p class="paragraph">
				Operator serwisu ww-notariusz.pl może być zobowiązany do udzielania informacji zebranych przez serwis upoważnionym organom na podstawie żądań zgodnych z prawem, w zakresie wynikającym z żądania.
			</p>
		</div>

		<h2>Rejestracja danych</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				Dane podane w formularzach serwisu ww-notariusz.pl mogą stanowić zbiór potencjalnych klientów, zarejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych (GIODO).
			</p>
			<p class="paragraph">
				Rejestracja danych w GIODO ma na celu zachowanie zgodności z obowiązującymi przepisami dotyczącymi ochrony danych osobowych.
			</p>
		</div>

		<h2>Zabezpieczenia danych</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				Operator serwisu ww-notariusz.pl podejmuje wszelkie niezbędne środki techniczne i organizacyjne w celu zabezpieczenia przetwarzanych danych osobowych przed dostępem osób nieupoważnionych.
			</p>
		</div>

		<h2>Kontakt</h2>
		<div class="privacy-sublist">
			<p class="paragraph">
				W przypadku pytań lub wątpliwości związanych z polityką prywatności serwisu ww-notariusz.pl, prosimy o kontakt pod adresem e-mail: kancelaria@ww-notariusz.pl lub telefonicznie pod numerem +48 (71) 307 00 89.
			</p>
			<p class="paragraph">
				Polityka prywatności serwisu może ulegać zmianom. Aktualna wersja polityki prywatności zawsze będzie dostępna na stronie internetowej serwisu ww-notariusz.pl.
			</p>
		</div>
	</div>
</section>

<style>
	.privacy-main {
		counter-reset: main;
	}

	.privacy-main h2 {
		counter-increment: main;

		&::before {
			content: counter(main) ". ";
		}
	}

	.privacy-sublist {
		counter-reset: sublist;
		margin-bottom: 4rem;
	}

	.privacy-sublist p {
		counter-increment: sublist;

		&::before {
			content: counter(main) "." counter(sublist) ". ";
		}
	}
</style>